import { nanoid } from 'nanoid';
import toast from 'react-hot-toast';
import Toast from '../../Molecules/Toast';

export default (context) => ({
  title,
  message,
  icon,
  onClick,
  onClose: onBeforeClose,
  id: explicitId,
  position,
  duration,
  top,
  right,
  bottom,
  left,
}) => {
  const id = explicitId ?? nanoid();

  const onClose = (event) => {
    event.stopPropagation();
    onBeforeClose?.();
    toast.dismiss(id);
  };

  const toastProps = { title, message, icon, top, right, bottom, left };
  const options = { id, position, duration };

  return toast.custom(
    Object.assign(
      (notificationConfig) => (
        <Toast
          {...toastProps}
          onClick={onClick}
          onClose={onClose}
          context={context}
          notificationConfig={notificationConfig}
        />
      ),
      { toastProps, options }
    ),
    options
  );
};
